export enum eModalRoles {
    ERROR = 'error',
    SUCCESS = 'success',
    CLOSE = 'close',
    REFRESH = 'refresh',
}